import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class MarkOrderAsPendingResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "number": 1,
                "state": "PENDING",
                "customer": {
                    "business_name": 2,
                    "number": 2,
                    "fantasy_name": "Customer",
                    "delivery_sites": [{
                        "name": "Customer Delivery Site",
                        "address": "Address",
                        "city": "City",
                    }],
                },
                "delivery_site": {
                    "name": "Customer Delivery Site",
                    "address": "Address",
                    "city": "City",
                },
                "delivery_date": "",
                "observations": "An Observation"
            },
            errors: []
        }
    }

    customer() {
        const customer = this.content().customer
        return {
            businessName: customer.business_name,
            customerCode: customer.code,
            fantasyName: customer.fantasy_name,
        }
    }

    deliverySite() {
        const deliverySite = this.content().delivery_site
        return {
            deliverySiteName: deliverySite.name,
            deliverySiteAddress: deliverySite.location.address,
            deliverySiteCity: deliverySite.location.city,
            deliveryDate: "",
        }
    }

    deliveryDate() {
        return this.content().delivery_date
    }

    observations() {
        return this.content().observations
    }

    state() {
        return this.content().state;
    }
}